import React from 'react';
import { Row } from 'react-table';
import * as react from '@coreui/react';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import CopyToClipboard from 'react-copy-to-clipboard';
import HelpInfoComponent from '../../help-info/help-info-component';
import shortTextFormatter from './short-text-formatter';
import Tools from '../../../tools';

type ExpandedRowProps = {
  row: Row;
  isRowOpen: boolean;
};

function expandedRow({ row, isRowOpen }: ExpandedRowProps): JSX.Element {
  return (
    <td colSpan={12}>
      <div className={isRowOpen ? 'open-row' : 'closed-row'}>
        <table className="w-100">
          <tbody>
            {/* Transaction Hash */}
            <tr>
              <td>
                <div className="expand-title">
                  Transaction hash:
                  <HelpInfoComponent
                    infoTitle="Transaction hash"
                    infoText="Transaction hash, or tx hash, is a unique identifier generated every time a transaction is created."
                  />
                </div>
              </td>
              <td>
                <div className="expand-value d-flex">
                  <react.CTooltip content={row.values.txId}>
                    <a href={row.values.explorer + row.values.txId} target="_blank" rel="noreferrer">
                      <span className="truncated">{Tools.shortenText(row.values.txId, 9)}</span>
                      <span className="truncated-tablet">{Tools.shortenText(row.values.txId, 25)}</span>
                      <span className="full-display-txId">{row.values.txId}</span>
                    </a>
                  </react.CTooltip>

                  <Button className="d-inline copy-button ms-2">
                    {/* This is a hack for mobile version. On mobile navigator.clipboard doesn't work that's why we are using CopyToClipboard */}
                    <CopyToClipboard
                      text={row.values.txId}
                      onCopy={() => {
                        toast('Copied to clipboard');
                      }}
                    >
                      <i className="icon-copy4" />
                    </CopyToClipboard>
                  </Button>
                </div>
              </td>
            </tr>

            {row.cells.map((cell) => {
              const shouldFormatText = ['contract', 'source', 'destination'].includes(cell.column.id);

              return (
                <tr {...cell.getCellProps()} className={`${cell.column.id}-expand`}>
                  <td>
                    <div className="expand-title">{cell.column.render('Header')}:</div>
                  </td>
                  <td>
                    <div className="expand-value">
                      {shouldFormatText ? (
                        <>
                          <span className="full-display">{shortTextFormatter(cell, {}, true)}</span>
                          <span className="truncated">{shortTextFormatter(cell, {}, false, 9)}</span>
                        </>
                      ) : (
                        cell.render('Cell')
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </td>
  );
}

export default expandedRow;
